<div [formGroup]="formData" *ngIf="formReady" class="searchFormContainer comparablesSearchContainer comparablesLeasesSearchContainer">
  <div class="searchFormContainerLeft">
    <table aria-hidden="true">
      <tbody>
        <tr *ngIf="selectedItemType==='comparablesProperty'">
          <td class="LabelContainer">
            <br />
            <span class="dialogLabel">
              {{selectedItem?.Oid}}: {{selectedDesc}}
            </span>
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesLease.transactionAssetClass' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="sector" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesLease.municipality' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="municipality" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesLease.postcode' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="postcode" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesLease.address1' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="address" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesLease.propertyType' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="primaryUse" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesLease.tenant' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="tenant" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesLease.rentEuroQmYear' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <div>
              <div class="comparablesSearchFromToInput">
                <input style="width:100%" kendo-numeric-text-box options="vm.numericTextbox" formControlName="rentFrom" />
              </div>
              <div class="comparablesSearchFromToInput">
                <input style="width:100%; margin-left: 20px;" kendo-numeric-text-box options="vm.numericTextbox" formControlName="rentTo" />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesLease.surfaceTotal' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <div>
              <div class="comparablesSearchFromToInput">
                <input style="width:100%" kendo-numeric-text-box options="vm.numericTextbox" formControlName="surfaceTotalFrom" />
              </div>
              <div class="comparablesSearchFromToInput">
                <input style="width: 100%; margin-left: 20px;" kendo-numeric-text-box options="vm.numericTextbox" formControlName="surfaceTotalTo" />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesLease.yearOfConstruction' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <div>
              <div class="comparablesSearchFromToInput">
                <input style="width:100%" kendo-numeric-text-box options="vm.numericTextboxYear" formControlName="yearOfConstructionFrom" />
              </div>
              <div class="comparablesSearchFromToInput">
                <input style="width: 100%; margin-left: 20px;" kendo-numeric-text-box options="vm.numericTextboxYear" formControlName="yearOfConstructionTo" />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesLease.energyLabel' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <kendo-dropdownlist *ngIf="reflistData.ref_lease_transaction_building_energy"
                                formControlName="energyPerformanceLabelId"
                                [data]="reflistData.ref_lease_transaction_building_energy"
                                textField="description"
                                valueField="oid"
                                id="form-energylabel"
                                [valuePrimitive]="true">
            </kendo-dropdownlist>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
